import type { JSX } from 'react';

import { SocialButton } from '@change-corgi/design-system-legacy/components/social';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { useShareClickHandlers } from '../hooks/useShareClickHandlers';

export function SharePanel({ movementId, objective }: { movementId: string; objective: string }): JSX.Element {
	const { onFacebookClick, onTwitterClick, onEmailClick, onWhatsAppClick } = useShareClickHandlers({
		movementId,
		objective,
	});

	return (
		<Flex sx={{ alignItems: 'center', justifyContent: 'center', gap: 16 }}>
			{/* FIXME translate labels (a11y) */}
			<SocialButton
				channel="facebook"
				filled
				iconOnly
				data-testid="movement-share-facebook"
				data-qa="movement-share-facebook"
				onClick={onFacebookClick}
			>
				share on facebook
			</SocialButton>
			<SocialButton
				channel="twitter"
				filled
				iconOnly
				aria-label="share on twitter"
				data-testid="movement-share-twitter"
				data-qa="movement-share-twitter"
				onClick={onTwitterClick}
			>
				share on twitter
			</SocialButton>
			<SocialButton
				channel="email"
				filled
				iconOnly
				aria-label="share through email"
				data-testid="movement-share-email"
				data-qa="movement-share-email"
				onClick={onEmailClick}
			>
				share through email
			</SocialButton>
			<SocialButton
				channel="whatsapp"
				filled
				iconOnly
				aria-label="share through whatsapp"
				data-testid="movement-share-whatsapp"
				data-qa="movement-share-whatsapp"
				onClick={onWhatsAppClick}
			>
				share through whatsapp
			</SocialButton>
		</Flex>
	);
}
